import { BulkSpreadsheet, parseBool, parseInt10, type BulkColumn } from '../shared/BulkSpreadsheet';
import { stockMovementService } from '@kss/api';
import type { StockMovementCreate } from '@kss/api';
import { loadProductOptions, loadStoreOptions, loadWarehouseOptions } from '../shared/formLoaders';

const columns: BulkColumn<StockMovementCreate>[] = [
  { key: 'productId', header: 'Product', required: true, dataType: 'lookup', loadOptions: loadProductOptions },
  { key: 'movementType', header: 'Type', sample: 'In' },
  { key: 'quantity', header: 'Qty', dataType: 'integer', parse: parseInt10 as never, required: true, sample: '10' },
  { key: 'movedAt', header: 'Date', dataType: 'date', sample: new Date().toISOString().slice(0, 10) },
  { key: 'storeId', header: 'Store', dataType: 'lookup', loadOptions: loadStoreOptions },
  { key: 'warehouseId', header: 'Warehouse', dataType: 'lookup', loadOptions: loadWarehouseOptions },
  { key: 'reference', header: 'Reference' },
  { key: 'notes', header: 'Notes' },
  { key: 'isActive', header: 'Active', dataType: 'boolean', parse: parseBool as never, sample: 'true' },
];

export default function BulkStockMovement() {
  return (
    <BulkSpreadsheet<StockMovementCreate> title="Bulk import stock movements" entityLabel="movement" backPath="/panel/stock-movements" columns={columns} module="StockMovement"
      onImport={async (rows) => {
        const payload = rows.map((r) => ({ ...r, quantity: Number(r.quantity ?? 0), isActive: r.isActive ?? true }));
        const created = await stockMovementService.create(payload);
        return { created: Array.isArray(created) ? created.length : payload.length };
      }}
    />
  );
}
